export default {
  people: 'People',
  topAdvisorsUniverse: 'Best Advisors',
  worstAdvisorsUniverse: 'Worst Advisors',
  connectedChannelsKeybe: 'Connected Keybe Channels',
  globalNewPeople: 'Global New People',
  globalNewBrands: 'Brands Monthly Signups',
  globalNewBrandsDaily: 'Brands Daily Signups',
  globalNewBrandsCumulative: 'Brands Cumulative Signups',
  globalNewBrandsWeekly: 'Brands Weekly Signups',
  globalTotalPeople: 'Global Total People',
  conversationsCampaign: 'Conversations / campaigns',
  managedThroughThePlatform: 'managed through the platform',
  globalAnswerTime: 'Global answer time',
  dailyAverage: 'Daily average',
  mostBilledServices: 'Most billed services',
  conversations: 'Conversations',
  campaigns: 'Campaigns',
  peopleSignedUp: 'People signed up',
  brandsSignedUp: 'Brands signed up',
  billing: 'Billing',
  total: 'Total',
  brands: 'Brands',
  licenses: 'Licenses',
  premiumPlan: 'Premium Plan',
  topBrands: 'Top 3 brands with most registered users in Keybe',
  withMostUsers: 'With most users',
  events: 'Events'
}
